// @ts-nocheck
import React, { useEffect, useState, useRef } from 'react';
import { supabase } from '../../../lib/supabaseClient';

interface Props {
  groupId: string;
}

interface Message {
  id: string;
  user_id: string;
  body: string;
  created_at: string;
}

const GroupChatPanel: React.FC<Props> = ({ groupId }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [text, setText] = useState('');
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fetchMessages();
    const channel = supabase
      .channel(`group-${groupId}-chat`)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'group_messages', filter: `group_id=eq.${groupId}` }, payload => {
        setMessages(prev => [...prev, payload.new as any]);
      })
      .subscribe();
    return () => {
      supabase.removeChannel(channel);
    };
  }, [groupId]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const fetchMessages = async () => {
    const { data } = await supabase
      .from('group_messages')
      .select('*')
      .eq('group_id', groupId)
      .order('created_at', { ascending: true })
      .limit(200);
    setMessages(data as Message[]);
  };

  const handleSend = async () => {
    if (!text.trim()) return;
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return;
    await supabase.from('group_messages').insert({ group_id: groupId, user_id: user.id, body: text.trim() });
    setText('');
  };

  return (
    <div className="flex flex-col h-96 border rounded overflow-hidden">
      <div className="flex-1 overflow-y-auto p-4 space-y-2 bg-gray-50 dark:bg-gray-900">
        {messages.map(msg => (
          <div key={msg.id} className="text-sm">
            <span className="font-medium mr-2">{msg.user_id.substring(0, 6)}</span>
            {msg.body}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
      <div className="flex gap-2 p-2 border-t bg-white dark:bg-gray-800">
        <input
          className="flex-1 border rounded p-2 text-sm"
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Type a message..."
          onKeyDown={e => {
            if (e.key === 'Enter') handleSend();
          }}
        />
        <button onClick={handleSend} className="px-3 py-1 bg-blue-600 text-white rounded text-sm">
          Send
        </button>
      </div>
    </div>
  );
};
export default GroupChatPanel; 